import { render, staticRenderFns } from "./standardRightAside.vue?vue&type=template&id=fab81ffa&scoped=true"
import script from "./standardRightAside.vue?vue&type=script&lang=js"
export * from "./standardRightAside.vue?vue&type=script&lang=js"
import style0 from "../scss/newStandard.scss?vue&type=style&index=0&id=fab81ffa&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab81ffa",
  null
  
)

export default component.exports